import {
  Component, OnDestroy, AfterViewInit,
  ElementRef, ViewChild, Output, EventEmitter, HostListener
} from '@angular/core';
import Keyboard from 'simple-keyboard';
import {VirtualKeyboardService} from './virtual-keyboard.service';

@Component({
  selector: 'app-virtual-keyboard',
  templateUrl: './virtual-keyboard.component.html',
  styleUrls: ['./virtual-keyboard.component.scss']
})
export class VirtualKeyboardComponent implements AfterViewInit, OnDestroy {
  visible$ = this.vkbService.visible$;
  @ViewChild('keyboardContainer') private keyboardContainer!: ElementRef<HTMLDivElement>;

  constructor(private vkbService: VirtualKeyboardService) {}
  @Output() keyPress = new EventEmitter<[string, any]>();

  private keyboard!: Keyboard;

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onKeyboardInteraction(event: Event) {
    event.preventDefault();
  }

  ngAfterViewInit() {
    try {
      this.keyboard = new Keyboard(this.keyboardContainer.nativeElement, {
        onChange: (input) => this.keyPress.emit([input, this.vkbService.activeInput]),
        onKeyPress: (button) => this.onKeyPress(button),
      });
      this.vkbService.registerKeyboard(this.keyboard);
    } catch (e) {}
  }

  onKeyPress(button: string) {
    if (button === '{enter}') {
      this.vkbService.submitActiveInput();
      return;
    }

    // Handle shift/caps toggle
    if (button === '{shift}' || button === '{lock}') {
      const currentLayout = this.keyboard.options.layoutName;
      this.keyboard.setOptions({
        layoutName: currentLayout === 'default' ? 'shift' : 'default'
      });
    }
  }

  setInput(value: string) {
    this.keyboard.setInput(value);
  }

  ngOnDestroy() {
    this.vkbService.unregisterKeyboard(this.keyboard);
    this.keyboard?.destroy();
  }
}
